// extracted by mini-css-extract-plugin
export var aircallIframe = "_gh-3";
export var fabContainer = "_gh-5";
export var fabRinging = "_gh-6";
export var loadingOverlay = "_gh-4";
export var pulse = "_gh-7";
export var widgetContent = "_gh-2";
export var widgetPanel = "_gh-0";
export var widgetPanelExpanded = "_gh-1";